import { render, staticRenderFns } from "./SsSelectOption.vue?vue&type=template&id=ce58f3d0&"
import script from "./SsSelectOption.vue?vue&type=script&lang=js&"
export * from "./SsSelectOption.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports